<div class="page-wrap">
    <div class="replace-matcard">
        <mat-card-content class="card-content">
            <mat-tab-group>
                <mat-tab>
                    <ng-template mat-tab-label>{{'General'}}</ng-template>
                    <form [formGroup]="companyForm" class="form-container">
                        <div class="form-container-content">
                            <div class="form-container-left">
                                <div class="form-item-container">
                                    <mat-card-title><b>{{company?.companySectionTitel}}</b></mat-card-title>
                                </div>
                                <div class="form-item-container">
                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>{{company?.companyNameLabel}}</mat-label>
                                        <input matInput autoComplete="off" formControlName="name">
                                    </mat-form-field>
                                </div>
                                <div class="form-item-container">
                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>{{company?.companyCountryLabel}}</mat-label>
                                        <input matInput autoComplete="off" formControlName="country">
                                    </mat-form-field>
                                </div>
                                <div class="form-item-container">
                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>{{company?.companyMailDomainsLabel}}</mat-label>
                                        <input matInput autoComplete="off" formControlName="mailDomains">
                                    </mat-form-field>
                                </div>
                                <div class="form-item-container">
                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>{{company?.companyMaxActiveUsersLabel}}</mat-label>
                                        <input matInput autoComplete="off" formControlName="maxActiveUsers">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-container-right">
                                <div class="form-item-container">
                                    <mat-card-title><b>{{company?.contactSectionTitel}}</b></mat-card-title>
                                </div>
                                <div class="form-item-container">
                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>{{company?.firstNameLabel}}</mat-label>
                                        <input matInput autoComplete="off" formControlName="contactFirstName">
                                    </mat-form-field>
                                </div>
                                <div class="form-item-container">
                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>{{company?.lastNameLabel}}</mat-label>
                                        <input matInput autoComplete="off" formControlName="contactLastName">
                                    </mat-form-field>
                                </div>
                                <div class="form-item-container">
                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>{{company?.phoneNumberLabel}}</mat-label>
                                        <input matInput autoComplete="off" formControlName="contactPhonenumber">
                                    </mat-form-field>
                                </div>
                                <div class="form-item-container">
                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>{{company?.emailLabel}}</mat-label>
                                        <input matInput autoComplete="off" formControlName="contactEmail">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{'Regions'}}</ng-template>
                    <form [formGroup]="companyForm">
                        <div class="form-item-container">
                            <mat-checkbox formControlName="ignoreDefaultRegion">
                                Ignore default region
                            </mat-checkbox>
                        </div>
                    </form>
                    <div class="region-table-container">
                        <table mat-table [dataSource]="regionList">
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef class="centerContent"><b>Selected</b></th>
                                <td mat-cell *matCellDef="let element" class="tableField">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? regionSelection.toggle(element) : null"
                                        [checked]="regionSelection.isSelected(element)"></mat-checkbox>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef class="centerContent"><b>Name</b></th>
                                <td mat-cell *matCellDef="let element" class="tableField">
                                    <span class="tdTextAlignTop">{{element.name}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="state">
                                <th mat-header-cell *matHeaderCellDef class="centerContent"><b>State</b></th>
                                <td mat-cell *matCellDef="let element" class="tableField">
                                    <span class="tdTextAlignTop">{{element.publishStateName}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="default">
                                <th mat-header-cell *matHeaderCellDef class="centerContent"><b>Default</b></th>
                                <td mat-cell *matCellDef="let element" class="tableField">
                                    <span class="tdTextAlignTop">{{element.isDefaultRegion}}</span>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="regionDisplayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: regionDisplayedColumns;"
                                [ngClass]="row.isDefaultRegion ? 'default-region' : ''" class="table-row-effect"
                                (click)="regionSelection.toggle(row)"></tr>
                        </table>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{'Graphics'}}</ng-template>
                    <div class="graphics-container">
                        <div class="graphics-checkbox-container">
                            <mat-checkbox class="checkbox-style" (change)="$event ? selectAllCategories($event) : null"
                                [checked]="graphicSelectionsHaveValue() && isAllCategorySelected()"
                                [indeterminate]="graphicSelectionsHaveValue() && !isAllCategorySelected()">
                                Select all
                            </mat-checkbox>
                            <div *ngFor="let category of categories">
                                <mat-checkbox *ngIf="category.id === 1" class="checkbox-style"
                                    (change)="$event ? selectSeatUtilisationGraphics() : null"
                                    [checked]="seatUtilisationGraphicsSelection.hasValue() && isAllSeatUtilisationGraphicsSelected()"
                                    [indeterminate]="seatUtilisationGraphicsSelection.hasValue() && !isAllSeatUtilisationGraphicsSelected()">
                                    Select all {{category.name}}
                                </mat-checkbox>
                                <mat-checkbox *ngIf="category.id === 2" class="checkbox-style"
                                    (change)="$event ? selectBaggageStorageGraphics() : null"
                                    [checked]="baggageStorageGraphicsSelection.hasValue() && isAllBaggageStorageGraphicsSelected()"
                                    [indeterminate]="baggageStorageGraphicsSelection.hasValue() && !isAllBaggageStorageGraphicsSelected()">
                                    Select all {{category.name}}
                                </mat-checkbox>
                                <mat-checkbox *ngIf="category.id === 3" class="checkbox-style"
                                    (change)="$event ? selectPassengerChangeGraphics() : null"
                                    [checked]="passengerChangeGraphicsSelection.hasValue() && isAllPassengerChangeGraphicsSelected()"
                                    [indeterminate]="passengerChangeGraphicsSelection.hasValue() && !isAllPassengerChangeGraphicsSelected()">
                                    Select all {{category.name}}
                                </mat-checkbox>
                            </div>
                        </div>
                        <div class="graphics-layout">
                            <div class="left-panel">
                                <div class="category">
                                    <h3>Baggage stowability</h3>
                                    <ul>
                                        <li *ngFor="let graphic of groupedGraphics.baggage">
                                            <ng-container
                                                *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                                        </li>
                                    </ul>
                                </div>

                                <div class="category">
                                    <h3>Seat availability</h3>
                                    <ul>
                                        <li *ngFor="let graphic of groupedGraphics.seats">
                                            <ng-container
                                                *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="right-panel">
                                <div class="category">
                                    <h3>Time need for passenger change</h3>

                                    <h4>a) Cumulative across all passengers</h4>

                                    <h5>Time need per door</h5>
                                    <ul>
                                        <li *ngFor="let graphic of groupedGraphics.timeNeed.cumulative.perDoor">
                                            <ng-container
                                                *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                                        </li>
                                    </ul>

                                    <h5>Comparison of several doors of one layout</h5>
                                    <ul>
                                        <li *ngFor="let graphic of groupedGraphics.timeNeed.cumulative.comparisonDoors">
                                            <ng-container
                                                *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                                        </li>
                                    </ul>

                                    <h5>Comparison of selected doors</h5>
                                    <ul>
                                        <li
                                            *ngFor="let graphic of groupedGraphics.timeNeed.cumulative.comparisonSelectedDoors">
                                            <ng-container
                                                *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                                        </li>
                                    </ul>

                                    <h5>Comparison of one door each with different travel mixes</h5>
                                    <ul>
                                        <li
                                            *ngFor="let graphic of groupedGraphics.timeNeed.cumulative.comparisonTravelMixes">
                                            <ng-container
                                                *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                                        </li>
                                    </ul>

                                    <h4>b) Total time need for all passengers</h4>
                                    <ul>
                                        <li *ngFor="let graphic of groupedGraphics.timeNeed.total">
                                            <ng-container
                                                *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <ng-template #graphicTemplate let-graphic="graphic">
                            <label>
                                <mat-checkbox [checked]="isGraphicSelected(graphic)" (change)="toggleGraphic(graphic)">
                                    <b>Layout </b>: {{ graphic.layoutName ?? '-' }} <b> | Train:</b> {{graphic.trainName
                                    ?? '-'}}
                                </mat-checkbox>
                            </label>
                        </ng-template>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{'Features'}}</ng-template>
                    <div class="feature-table-container">
                        <table mat-table #table [dataSource]="featureList">
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef class="text-align-left">
                                    <mat-checkbox (change)="$event ? feeatureSelectionToggle() : null"
                                        [checked]="featureSelection.hasValue() && isAllFeaturesSelected()"
                                        [indeterminate]="featureSelection.hasValue() && !isAllFeaturesSelected()">
                                    </mat-checkbox>
                                    <b>Select all Features</b>
                                </th>
                                <td mat-cell *matCellDef="let row" class="text-align-left">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? featureSelection.toggle(row) : null"
                                        [checked]="featureSelection.isSelected(row)">
                                    </mat-checkbox>
                                    {{row.name}}
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="featureDisplayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: featureDisplayedColumns;" class="table-row-effect"
                                (click)="featureSelection.toggle(row)">
                            </tr>
                        </table>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <div class="content-buttons margin-top-15">
            <button mat-raised-button class="color" (click)="navigateBack()">{{company?.buttonBack}}</button>
            <div class="spacer"></div>
            <!-- <button mat-raised-button class="color" (click)="debug()"
            >Debug</button> -->
            <button mat-raised-button class="color" (click)="onSubmit()"
                [disabled]="companyForm.invalid">{{company?.buttonSave}}</button>
        </div>
    </div>
</div>
<hr class="line">